import { ArrowRight, MessageCircle } from "lucide-react";

export default function FinalCta() {
  return (
    <section className="py-20">
      <div className="relative overflow-hidden rounded-3xl border border-primary-border bg-primary-dim px-8 py-16 text-center md:px-16">
        {/* Background glow */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 opacity-40"
          style={{
            backgroundImage:
              "radial-gradient(circle at 50% 0%, oklch(0.6 0.15 165 / 0.3), transparent 60%)",
          }}
        />

        <div className="relative">
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-text sm:text-4xl md:text-5xl">
            Stop building infrastructure.
            <br />
            <span className="text-primary">Start shipping agents.</span>
          </h2>
          <p className="mx-auto mb-8 max-w-lg text-base leading-relaxed text-text-muted">
            Free to start. No credit card required. Your first agent is running in minutes — not
            months. 1M free tokens included; bring your own model key after that.
          </p>

          <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <a
              href="https://agents.anter.ai"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-primary bg-primary px-7 py-3.5 text-sm font-bold text-primary-text-strong transition hover:opacity-90"
            >
              Start Building Free
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="mailto:hello@anter.ai"
              className="inline-flex items-center gap-2 rounded-full border border-border bg-bg px-7 py-3.5 text-sm font-semibold text-text transition hover:border-primary-border hover:bg-bg-hover"
            >
              <MessageCircle className="h-4 w-4 text-primary" />
              Talk to the team
            </a>
          </div>

          <p className="mt-6 text-xs text-text-faint">
            Free tier &middot; No credit card &middot; 1M free tokens, then bring your own key
            &middot; Production-ready from day one
          </p>
        </div>
      </div>
    </section>
  );
}
